import { DynamicTableStateless } from '@atlaskit/dynamic-table';
import { SpinnerMask } from '@atlassian/amkt-common';
import { useHistory } from '@atlassian/mpac-ui';
import { DynamicTableUtils } from '@atlassian/mpac-utils';
import isEqual from 'lodash/isEqual';
import React, { useState } from 'react';
import { PAGINATION_LIMIT } from "../../../constants/Preferences";
import NoResultView from "../../../utils/NoResultView";
import ErrorMessage from "../Common/ErrorMessage";
import { REPORTS_NO_RESULT_SUBTITLE, REPORTS_NO_RESULT_TITLE } from "../PartnerReports.constants";
import { licenseDetailsConfig } from "../ReportDetails/ReportDetailsConfig/LicenseDetailsConfig";
import ReportDetailsModal from "../ReportDetails/ReportDetailsModal";
import { getNewReportPathname, getNewSearch } from "../ReportsFilters/ReportFilters.utils";
import { useLicensesReport } from "./hooks";
import { getLicenseReportBody, getLicenseReportHeader } from "./LicenseReportsTableData";

const LicenseReports = props => {
  const history = useHistory();
  const {
    licenses,
    pending,
    error
  } = useLicensesReport(props.mpacBaseUrl, props.partnerId, props.queryParams);
  const [selectedLicense, setSelectedLicense] = useState();
  const totalCount = licenses === null || licenses === void 0 ? void 0 : licenses.totalCount;
  const rowsPerPage = DynamicTableUtils.getRowsPerPage(totalCount, PAGINATION_LIMIT);
  const offset = props.queryParams.offset || 0; // eg: If offset is 10, page number would be 2 (10/10 + 1)

  const pageNum = Number.parseInt(offset.toString(), 10) / rowsPerPage + 1;

  const updateQueryParams = (queryParam, value) => {
    history.replace({
      pathname: getNewReportPathname(props.partnerId, props.reportName, false, ''),
      search: getNewSearch(props.queryParams, queryParam, value)
    });
  };

  const getReportsLink = (queryParam, value, columnName) => {
    const reportName = columnName === 'licenseId' ? 'transactions' : props.reportName;
    const pathname = getNewReportPathname(props.partnerId, reportName, false, '');
    const search = getNewSearch({}, queryParam, value);
    return pathname + search;
  };

  const onViewLicenseClick = licenseDetails => setSelectedLicense(licenseDetails);

  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(ErrorMessage, {
    error: error.error,
    status: error.status
  }), !error && /*#__PURE__*/React.createElement(SpinnerMask, {
    active: pending,
    size: 50
  }, /*#__PURE__*/React.createElement(DynamicTableStateless, {
    head: getLicenseReportHeader(),
    isLoading: pending,
    rows: getLicenseReportBody((licenses === null || licenses === void 0 ? void 0 : licenses.licenses) || [], getReportsLink, onViewLicenseClick),
    rowsPerPage: rowsPerPage,
    page: pageNum,
    onSetPage: page => updateQueryParams('offset', ((page - 1) * PAGINATION_LIMIT).toString()),
    totalRows: totalCount,
    defaultSortKey: "licenseId",
    defaultSortOrder: "ASC",
    emptyView: /*#__PURE__*/React.createElement(NoResultView, {
      title: REPORTS_NO_RESULT_TITLE,
      subtitle: REPORTS_NO_RESULT_SUBTITLE
    })
  })), selectedLicense && /*#__PURE__*/React.createElement(ReportDetailsModal, {
    header: "License details",
    reportDetails: selectedLicense,
    onClose: () => setSelectedLicense(),
    reportDetailsConfig: licenseDetailsConfig
  }));
};

export default /*#__PURE__*/React.memo(LicenseReports, isEqual);